<div id="teaching-staff" class="inner-page">
  <div class="container-fluid px-lg-5">
    <h2 class="title">Teaching Staff</h2>
    <p class="inner-lead mt-3">
      Shah Satnam Ji Girls' College, Sirsa has a dedicated and highly qualified teaching faculty committed to academic
      excellence and holistic student development. Click on any member to view their full profile.
    </p>

    <hr class="divider">

    <!-- Faculty Card Grid -->
    <div class="row g-4 mt-2">
      <div class="col-xl-3 col-lg-4 col-md-6" *ngFor="let staff of staffList">
        <div class="faculty-card shadow-sm" (click)="openDetails(staff)">
          <div class="faculty-card-header">
            <div class="faculty-avatar-container">
              <img *ngIf="staff.image" [src]="staff.image" [alt]="staff.name" class="avatar-img">
              <div *ngIf="!staff.image" class="avatar-initials">
                {{ getInitials(staff.name) }}
              </div>
            </div>
          </div>
          <div class="faculty-card-body p-4 text-center">
            <h5 class="faculty-name fw-bold mb-2">{{ staff.name }}</h5>
            <div class="faculty-badge-container mb-3">
              <span class="faculty-designation-badge">{{ staff.designation }}</span>
            </div>
            <p class="faculty-dept text-muted small mb-3">
              <i class="fa fa-briefcase me-1"></i> {{ staff.department }} Department
            </p>
            <div class="faculty-card-footer">
              <span class="btn-view-profile">
                View Profile <i class="fa fa-arrow-right ms-1"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- PDF Backup Link -->
    <div class="mt-section text-center">
      <p class="text-muted">Looking for the full departmental staff lists?</p>
      <a href="/assets/pdf/Website staff data dt. 23.05.26.pdf" target="_blank" class="pdf-download-btn">
        <i class="fa fa-download me-2"></i> Download Full Teaching Staff List (PDF)
      </a>
    </div>

  </div>
</div>

<!-- Modal Implementation -->
<div class="custom-modal-backdrop" *ngIf="showModal" (click)="closeModal()">
  <div class="custom-modal-content" (click)="$event.stopPropagation()">
    <button class="close-btn" (click)="closeModal()">&times;</button>

    <div class="modal-body-custom p-4" *ngIf="selectedStaff">
      <div class="row g-4 align-items-center">
        <div class="col-md-5 text-center">
          <div class="modal-avatar-wrapper">
            <div class="modal-avatar">
              <img *ngIf="selectedStaff.image" [src]="selectedStaff.image" [alt]="selectedStaff.name"
                class="img-fluid rounded">
              <div *ngIf="!selectedStaff.image" class="modal-avatar-initials">
                {{ getInitials(selectedStaff.name) }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-7">
          <h2 class="fw-bold text-primary mb-2">{{ selectedStaff.name }}</h2>
          <h5 class="text-muted mb-4">{{ selectedStaff.designation }} - {{ selectedStaff.department }} Department</h5>

          <div class="detail-row">
            <span class="detail-label">Qualification:</span>
            <span class="detail-value">{{ selectedStaff.qualification }}</span>
          </div>

          <div class="detail-row" *ngIf="selectedStaff.phone">
            <span class="detail-label">Phone:</span>
            <span class="detail-value">
              <a href="tel:{{ selectedStaff.phone }}" class="text-decoration-none fw-semibold">
                <i class="fa fa-phone me-1"></i> {{ selectedStaff.phone }}
              </a>
            </span>
          </div>

          <div class="detail-row" *ngIf="selectedStaff.workingSince">
            <span class="detail-label">Working Since:</span>
            <span class="detail-value">{{ selectedStaff.workingSince }}</span>
          </div>

          <div class="detail-row" *ngIf="selectedStaff.academicAchievements?.booksPublished">
            <span class="detail-label">Books/Chapters:</span>
            <span class="detail-value">{{ selectedStaff.academicAchievements.booksPublished }}</span>
          </div>

          <div class="detail-row" *ngIf="selectedStaff.academicAchievements?.researchPapers">
            <span class="detail-label">Research Papers:</span>
            <span class="detail-value">{{ selectedStaff.academicAchievements.researchPapers }}</span>
          </div>

          <div class="detail-row" *ngIf="selectedStaff.academicAchievements?.conferences">
            <span class="detail-label">Conferences:</span>
            <span class="detail-value">{{ selectedStaff.academicAchievements.conferences }}</span>
          </div>

          <div class="mt-4">
            <p class="small text-muted"><em>Committed to nurturing excellence at Shah Satnam Ji Girls' College.</em></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>